/* index.js */

"use strict";

module.exports = {
    Section: require("./src/app/EditorSection"),
    EditorSectionComponent: require("./src/app/EditorSectionComponent"),
};
